// extracted by mini-css-extract-plugin
module.exports = {"container":"eula_container__KkdmA"};